var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"servicios"}},[_c('div',{staticClass:"dvTitle"},[_vm._t("title")],2),_c('div',{staticClass:"dvContenido"},[_vm._t("contenido")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }